import { Link } from 'react-router-dom';

const reasons = [
  { icon: 'ri-global-line', title: '15+ ans d\'expérience', desc: 'Expertise approfondie dans les secteurs pharmaceutique, chimique fin, alimentaire et industriel.' },
  { icon: 'ri-translate-2', title: 'Bilingue EN / FR', desc: 'Service complet en anglais et en français — sans barrières, sans malentendus.' },
  { icon: 'ri-lock-line', title: 'Confidentialité totale', desc: 'Votre identité et votre stratégie restent protégées tout au long de chaque engagement.' },
  { icon: 'ri-map-pin-line', title: '4 régions mondiales', desc: 'Réseaux actifs en Amérique du Nord, Europe, Chine et Inde.' },
];

export default function ServicesCTAFr() {
  return (
    <>
      {/* Why us strip */}
      <section className="w-full bg-stone-50 py-16 px-6 md:px-16 border-t border-stone-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <span className="text-emerald-600 text-xs font-bold uppercase tracking-widest">Pourquoi MAX-Sourcing</span>
            <h2
              className="text-3xl md:text-4xl font-extrabold text-stone-800 mt-3"
              style={{ fontFamily: "'DM Serif Display', serif" }}
            >
              La différence est dans les détails
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {reasons.map((r) => (
              <div key={r.title} className="bg-white rounded-lg border border-stone-100 p-6 flex flex-col gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-emerald-50 text-emerald-600">
                  <i className={`${r.icon} text-xl`} />
                </div>
                <h4 className="text-stone-800 font-bold text-sm">{r.title}</h4>
                <p className="text-stone-500 text-xs leading-relaxed">{r.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA banner */}
      <section className="w-full relative overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://public.readdy.ai/ai/img_res/a4871a4f8a8255d9dc8a487b9a4114ce.jpg')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/85 via-stone-900/70 to-emerald-900/60" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-16 py-20 flex flex-col lg:flex-row items-center justify-between gap-10">
          <div className="max-w-2xl">
            <span className="text-emerald-400 text-xs font-bold uppercase tracking-widest block mb-4">Prêt à commencer ?</span>
            <h2
              className="text-3xl md:text-5xl font-extrabold text-white leading-tight mb-4"
              style={{ fontFamily: "'DM Serif Display', serif" }}
            >
              Résolvons votre défi d&apos;approvisionnement
            </h2>
            <p className="text-white/70 text-base leading-relaxed">
              Que vous ayez besoin d&apos;un seul fournisseur qualifié ou d&apos;une refonte complète de votre chaîne d&apos;approvisionnement, notre équipe est prête à s&apos;engager — en toute confidentialité, professionnellement et avec une pleine conscience réglementaire.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row lg:flex-col gap-4 shrink-0">
            <Link
              to="/fr/contact"
              className="bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-sm px-8 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-center"
            >
              Contactez-nous aujourd&apos;hui
            </Link>
            <Link
              to="/fr/fournisseurs"
              className="border-2 border-white/40 hover:border-white text-white font-bold text-sm px-8 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-center"
            >
              Devenez fournisseur
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
